import { EditIcon } from "assets";
import { CustomTooltip, SmallScreenModel, SwitchButton } from "components";
import React, { useState } from "react";
import { DcddMembershipPlanProp } from "../store/actionType";
import HandleUpdateDcddPlan from "./HandleUpdateDcddPlan";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import HandleUpdateStatus from "./HandleUpdateStatus";
import { DcddMembershipStatus } from "props/enum";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

const ActionButton: React.FC<{ items: DcddMembershipPlanProp }> = ({ items }) => {
  const [isEditModel, setEditModel] = useState(false);
  const [isStatusModel, setStatusModel] = useState(false);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_DCDD_MEMBERSHIP_PLAN));
  if (isPermitted)
    return (
      <>
        <div className="flex flex-row gap-2 justify-center items-center">
          <CustomTooltip title="Edit membership plan" placement="bottom">
            <button
              className="hover:text-primary-500"
              onClick={() => setEditModel(true)}
            >
              <EditIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip
            title={
              items.join_date === DcddMembershipStatus.Active
                ? DcddMembershipStatus.Inactive
                : DcddMembershipStatus.Active
            }
            placement="bottom"
          >
            <button onClick={() => setStatusModel(true)}>
              <SwitchButton
                id={"status"}
                name={"status"}
                value={items.status === DcddMembershipStatus.Active}
                onChange={() => setStatusModel(true)}
              />
            </button>
          </CustomTooltip>
        </div>
        <SmallScreenModel setShowModal={setEditModel} showModal={isEditModel}>
          <HandleUpdateDcddPlan
            dcddMembershipData={items}
            closeModal={() => setEditModel(false)}
          />
        </SmallScreenModel>
        <SmallScreenModel setShowModal={setStatusModel} showModal={isStatusModel}>
          <HandleUpdateStatus
            onClose={() => setStatusModel(!isStatusModel)}
            dcddMembershipData={items}
          />
        </SmallScreenModel>
      </>
    );
  return <></>;
};

export default ActionButton;
